export default {
  createTopic: '/topic/createTopic',
  getTopicsOfADivisionOfASubject: '/topic/getTopicsOfADivisionOfASubject',
  markAsImplemented: '/topic/markAsImplemented',
  markAsUnimplemented: '/topic/markAsUnimplemented',
  deleteTopic: '/topic/deleteTopic'
}
